// Local translations
export const T = {
  en_GB: {
    thankYou: "Thank You!",
    submittedSuccessfully: "Your information has been submitted successfully",
    thankYouName: (name: string) => `Thank you, ${name}!`,
    responsesSaved: "Your responses have been saved and your advisor will review them shortly.",
    closeWindow: "You can now close this window.",
  },
  nb_NO: {
    thankYou: "Takk!",
    submittedSuccessfully: "Informasjonen din er sendt inn",
    thankYouName: (name: string) => `Takk, ${name}!`,
    responsesSaved: "Svarene dine er lagret og rådgiveren din vil gjennomgå dem snart.",
    closeWindow: "Du kan nå lukke dette vinduet.",
  },
} as const;
